export default __webpack_public_path__ + "static/media/b3.6a27e9bf.svg";